import { trackLeadCreatedResponse } from "../../shared/openaiLeadTracking.mjs";
import { useState, useEffect } from "react";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Image from "next/image";
import {
  FaUser,
  FaEnvelope,
  FaLocationArrow,
  FaPhone,
  FaSchool,
  FaMapMarkerAlt,
  FaBuilding,
  FaCheckCircle,
} from "react-icons/fa";
import { trackLeadHybrid } from "@/lib/metaLeadTracking";
import LeadOtpVerification from "@/components/common/LeadOtpVerification";

const API_URL = process.env.NEXT_PUBLIC_ADMIN_URL;

const CounsellingModal = ({
  isOpen,
  onClose,
  college,
  counselling,
  course,
  location,
}) => {
  const selectedEntity = college ? college : counselling;
  const determineLeadSource = () => (college ? "college" : "counselling"); // Determine leadSource dynamically
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    phone: "",
    city: "",
    state: "",
    location: location || selectedEntity?.location || "Not Available",
    interestedIn: selectedEntity?.title || "",
    courseInterested: Array.isArray(course) ? course.join(", ") : "N/A",
    givenNeetExam: "",
    neetRank: "",
    neetScore: "",
    leadSource: determineLeadSource(), // Added leadSource dynamically
  });
  const [isSuccess, setIsSuccess] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isOtpVerified, setIsOtpVerified] = useState(false);
  useEffect(() => {
    if (isOpen) {
      document.documentElement.style.overflow = "hidden";
      document.body.style.overflow = "hidden";
    } else {
      document.documentElement.style.overflow = "auto";
      document.body.style.overflow = "auto";
    }
    return () => {
      document.documentElement.style.overflow = "auto";
      document.body.style.overflow = "auto";
    };
  }, [isOpen]);

  useEffect(() => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      interestedIn: selectedEntity?.title || "",
      courseInterested: Array.isArray(course) ? course.join(", ") : "N/A",
      leadSource: determineLeadSource(),
      location: location || selectedEntity?.location || "Not Available", // Update dynamically
    }));
  }, [college, counselling, course, location]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Log to check if the function is being called
    if (loading) return; // Prevent double submission
    if (!isOtpVerified) {
      toast.error("Please verify your phone via WhatsApp OTP before submitting.");
      return;
    }

    setLoading(true); // Set loading before submission

    const requestData1 = {
      name: formData.fullName,
      email: formData.email,
      phone: formData.phone,
      state: formData.state || "",
      city: formData.city || "",
      leadSource: formData.leadSource,
      neetScore: formData.neetScore || "",
      neetRank: formData.neetRank || "",
      location: formData.location || "",
      college_Name: formData.interestedIn || "", // Add interestedIn as college_Name
    };

    // stop syanamte submission
    // const requestData2 = {
    //   fullName: formData.fullName,
    //   email: formData.email,
    //   phone: formData.phone,
    //   state: formData.state || "",
    //   city: formData.city || "",
    //   tags: formData.leadSource,
    //   neetScore: formData.neetScore || "",
    //   neetRank: formData.neetRank || "",
    //   location: formData.location || "",
    //   title: formData.interestedIn || "", // Add interestedIn as college_Name
    //   college_Name: formData.interestedIn || "", // Add interestedIn as college_Name
    // };

    try {
      // Submit data to the first API
      const response1 = await axios.post(`${API_URL}/api/leads`, requestData1, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      trackLeadCreatedResponse(response1);

      // stop syanamte submission
      // const response2 = await axios.post(
      //   `${process.env.NEXT_PUBLIC_API_URL}/api/contacts/upsert`,
      //   requestData2,
      //   {
      //     headers: {
      //       "Content-Type": "application/json",
      //     },
      //   }
      // );

      if (
        response1.status === 201 || response1.data.success
      ) {
        await trackLeadHybrid({
          email: formData.email,
          phone: formData.phone,
          value: 49,
          currency: "INR",
          eventSourceUrl: "/thank-you",
          dedupeKey: `${formData.leadSource}_${formData.phone}_${formData.email}`,
          customData: {
            lead_source: formData.leadSource,
            city: formData.city || "",
            state: formData.state || "",
          },
        });

        // Show success UI
        setIsSuccess(true);
        toast.success(response1.data.message || "Request submitted successfully.");
        setTimeout(() => {
          setIsSuccess(false);
          onClose();
        }, 3000);
      } else {
        // Show error toast with the message from the API if available
        toast.error(
          response1.data.message ||
            "Failed to submit your request. Please try again."
        );
      }
    } catch (error) {
      toast.error("An error occurred. Please try again.");
    } finally {
      setLoading(false); // Always re-enable the button
    }
  };

  if (!isOpen) return null;
  const name = formData.fullName;
  return (
    <>
      <ToastContainer />
      <div className="fixed inset-0 p-4 flex items-center justify-center bg-gray-900 bg-opacity-70 z-50">
        <div className="bg-white mt-16 sm:mt-0 rounded-lg shadow-lg w-full max-w-5xl max-h-screen sm:max-h-[90vh] overflow-y-auto sm:overflow-hidden relative flex">
          <div className="hidden md:block w-1/2 p-1 rounded-l-lg overflow-y-auto ">
            {/* Banner Section */}
            <img
              src="/images/leftsidegraphics.jpg"
              alt="Banner"
              width={500} // Set a fixed width or use responsive styles
              height={500} // Set a fixed height or use responsive styles
              className="w-full h-full object-fit rounded-l-lg aspect-square"
            />
          </div>
          <div className="w-full md:w-1/2 p-6 overflow-y-auto">
            <button
              onClick={onClose}
              className="absolute top-2  right-4 text-[#ff9245] hover:text-gray-800 text-xl"
            >
              ✖
            </button>

            {isSuccess ? (
              <div className="flex flex-col items-center justify-center h-full">
                <FaCheckCircle className="text-green-500 text-6xl mb-4" />
                <h2 className="text-2xl font-bold text-gray-800 mb-4 text-center">
                  Success!
                </h2>
                <p className="text-gray-600 mb-6 text-center">
                  Your request has been submitted successfully. We will contact
                  you soon for further assistance.
                </p>
              </div>
            ) : (
              <>
                <h2 className="text-lg lg:text-2xl font-bold text-gray-800 mb-4 text-center">
                  Begin Your Counselling Journey in <br />
                  <span className="text-[#ff9245] text-lg lg:text-xl">
                    {formData.location || "Your Preferred State"}
                  </span>
                </h2>

                {college && (
                  <div className="text-sm text-gray-600 mb-3">
                    <p>
                      <strong>Course:</strong> {formData.courseInterested}
                    </p>
                  </div>
                )}

                <form
                  onSubmit={handleSubmit}
                  className="grid grid-cols-1 sm:grid-cols-2 gap-4"
                >
                  <div className="relative col-span-2 sm:col-span-1">
                    <FaUser className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
                    <input
                      type="text"
                      name="fullName"
                      placeholder="Full Name"
                      value={name}
                      onChange={handleChange}
                      className="w-full border rounded-md px-10 py-2 text-sm focus:outline-none focus:ring-1 focus:ring-[#ff9245]"
                      required
                    />
                  </div>
                  <div className="relative col-span-2 sm:col-span-1">
                    <FaEnvelope className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
                    <input
                      type="email"
                      name="email"
                      placeholder="Email"
                      value={formData.email}
                      onChange={handleChange}
                      className="w-full border rounded-md px-10 py-2 text-sm focus:outline-none focus:ring-1 focus:ring-[#ff9245]"
                      required
                    />
                  </div>
                  <div className="col-span-2 sm:col-span-1">
                    <LeadOtpVerification
                      phone={formData.phone}
                      otpEnabled={false}
                      onPhoneChange={(value) =>
                        setFormData((prev) => ({ ...prev, phone: value }))
                      }
                      inlinePhoneField
                      phonePlaceholder="Phone No"
                      phoneInputClassName="border rounded-md py-2 px-3 text-sm focus:outline-none focus:ring-1 focus:ring-[#ff9245]"
                      onVerifiedChange={setIsOtpVerified}
                    />
                  </div>
                  <div className="relative">
                    <FaLocationArrow className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
                    <input
                      type="text"
                      name="city"
                      placeholder="City"
                      value={formData.city}
                      onChange={handleChange}
                      className="w-full border rounded-md px-10 py-2 text-sm focus:outline-none focus:ring-1 focus:ring-[#ff9245]"
                      required
                    />
                  </div>
                  <div className="relative col-span-2">
                    <FaMapMarkerAlt className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
                    <input
                      type="text"
                      name="state"
                      placeholder="State"
                      value={formData.state}
                      onChange={handleChange}
                      className="w-full border rounded-md px-10 py-2 text-sm focus:outline-none focus:ring-1 focus:ring-[#ff9245]"
                      required
                    />
                  </div>
                  <div className="relative col-span-2">
                    <FaSchool className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
                    <input
                      type="text"
                      name="interestedIn"
                      value={formData.interestedIn}
                      readOnly
                      className="w-full border rounded-md px-10 py-2 text-sm bg-gray-100 focus:outline-none focus:ring-2 focus:ring-[#ff9245] focus:ring-opacity-50"
                    />
                  </div>
                  <div className="relative col-span-2">
                    <FaBuilding className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
                    <input
                      type="text"
                      name="leadSource"
                      value={formData.leadSource}
                      readOnly
                      className="w-full border rounded-md px-10 py-2 text-sm bg-gray-100 focus:outline-none focus:ring-2 focus:ring-[#ff9245] focus:ring-opacity-50"
                    />
                  </div>

                  {/* NEET Exam Question */}
                  <div className="text-sm text-gray-600 mt-3 col-span-2">
                    <p>
                      <strong>Have you given the NEET Exam?</strong>
                    </p>
                    <label className="mr-4">
                      <input
                        type="radio"
                        name="givenNeetExam"
                        value="yes"
                        checked={formData.givenNeetExam === "yes"}
                        onChange={handleChange}
                        className="mr-1"
                      />{" "}
                      Yes
                    </label>
                    <label>
                      <input
                        type="radio"
                        name="givenNeetExam"
                        value="no"
                        checked={formData.givenNeetExam === "no"}
                        onChange={handleChange}
                        className="mr-1"
                      />{" "}
                      No
                    </label>
                  </div>

                  {/* Show Rank and Marks fields only if 'Yes' is selected */}
                  {formData.givenNeetExam === "yes" && (
                    <>
                      <input
                        type="text"
                        name="neetRank"
                        placeholder="NEET Rank"
                        value={formData.neetRank}
                        onChange={handleChange}
                        className="w-full border rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-1 focus:ring-[#ff9245]"
                        required
                      />
                      <input
                        type="text"
                        name="neetScore"
                        placeholder="NEET Marks"
                        value={formData.neetScore}
                        onChange={handleChange}
                        className="w-full border rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-1 focus:ring-[#ff9245]"
                        required
                      />
                    </>
                  )}

                  <div className="flex justify-center space-x-3 mt-4 col-span-2">
                    <button
                      type="submit"
                      disabled={loading}
                      className={`w-full px-4 py-2 text-white rounded-lg text-lg transition duration-300 ${
                        loading
                          ? "bg-gray-400 cursor-not-allowed"
                          : "bg-[#ff9245] hover:bg-[#ff7f32] cursor-pointer"
                      }`}
                    >
                      {loading ? "Submitting..." : "Submit"}
                    </button>
                  </div>
                </form>
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default CounsellingModal;
